import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LanguagesApiDTO } from '../../languages/languages.dto';
import { LanguageRepo } from '../../languages/language.repo';
import { ThemeService } from '@shared/services/themeService/theme.service';
import { AuthStoreService } from '@features/auth/infrastructure/services/auth-store/auth-store.service';
import { AuthApiService } from '@features/auth/infrastructure/services/auth-api/auth-api.service';
import { NavigationEnd, Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { SidebarComponent } from '../../sidebar/sidebar.component';
import { filter, takeUntil } from 'rxjs';
import { UnsubscribeService } from '@shared/services/unsubscribe.service';
import { RolePermissionService } from '@shared/services/role-permission.service';

@Component({
  selector: 'app-menu-modal',
  standalone: true,
  imports: [
    NgbDropdownModule,
    TranslocoDirective,
    SidebarComponent,
  ],
  providers: [
    UnsubscribeService,
  ],
  templateUrl: './menu-modal.component.html',
  styleUrl: './menu-modal.component.scss'
})
export class MenuModalComponent implements OnInit{
	activeModal = inject(NgbActiveModal);
  private unsub = inject(UnsubscribeService);
  #rolePermissionService = inject(RolePermissionService);
  user = this.authStoreService.user();

  selectedLanguage: LanguagesApiDTO | undefined;
  languageList: LanguagesApiDTO[] = [];
  constructor(private langRepo: LanguageRepo,
              private themeService: ThemeService,
              private authStoreService: AuthStoreService,
              private authApiService: AuthApiService,
              private router: Router,
  ) {
  }

  ngOnInit(): void {
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd), takeUntil(this.unsub.$unsub))
        .subscribe((event: any) => {
          this.activeModal.close()
        })
  }

  logout() {
    this.authApiService.logout(this.authStoreService.refreshToken()!).pipe(takeUntil(this.unsub.$unsub)).subscribe(() => {
      this.authStoreService.logout();
      this.router.navigate(['/auth']);
      this.activeModal.dismiss();
    });
  }

  changeTheme() {
    if (this.themeService.theme() == 'dark') {
      this.themeService.theme.set('light');
    } else {
      this.themeService.theme.set('dark') ;
    }
  }

  getUserName() {
    return this.user?.firstname || this.user?.username || '';
  }

  isRoutePermitted(route: string) {
    return this.#rolePermissionService.isRoutePermitted(route);
  }
}
